import { connect } from 'react-redux'
import Groups from './groups'
import { removePupilFromGroup } from '../../../../../../../stores/profile/profile.actions'
import { getPupilGroupIds } from '../../../../../../../stores/profile/profile.selectors'

const mapStateToProps = state => ({
  groups: getPupilGroupIds(state)
})

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onRemove: groupId =>
    dispatch(
      removePupilFromGroup({
        student_account_id: ownProps.pupilId,
        group_id: groupId
      })
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Groups)
